import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { MonitoringAPI } from '@modules/monitoring/api';
import { monitoringSetTripStatusRoutine } from '@modules/monitoring/actions';
import { SetTripStatusRequest } from '@common/types/dictionaries/monitoring';

// Получает данные прогресса доставок
function* worker(action: PayloadAction<SetTripStatusRequest>) {
  const { request, success, failure, fulfill } = monitoringSetTripStatusRoutine;
  const { id, status } = action.payload;
  try {
    yield put(request());
    const {
      data: { data }
    } = yield call(MonitoringAPI.setTripStatus, { id, status });
    yield put(success(data));
  } catch (error) {
    yield put(failure({ error }));
  } finally {
    yield put(fulfill());
  }
}

export function* monitoringSetTripStatusWatcher() {
  yield takeLatest(monitoringSetTripStatusRoutine.trigger, worker);
}
